import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { UserInfoService } from '@pool-league/frontend-shared-util-auth';

export interface AvatarUserInfo {
  bbUserName?: string;
  displayName?: string;
  avatar?: string;
}

@Component({
  selector: 'lib-avatar',
  imports: [CommonModule, NgOptimizedImage],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  static readonly SIZE = {
    xs: 32,
    sm: 64,
    md: 96,
    lg: 128,
    xl: 192,
  } as const;

  readonly #userInfoService = inject(UserInfoService);

  readonly user = input.required<AvatarUserInfo>();
  readonly size = input<keyof typeof AvatarComponent.SIZE>('xs');
  readonly round = input(true);
  readonly rosette = input<string | undefined>();

  readonly pixels = computed(() => AvatarComponent.SIZE[this.size()]);
  readonly avatar = computed(() => this.user().avatar);
  readonly alt = computed(() =>
    this.#userInfoService.isMe(this.user().bbUserName)
      ? 'Me'
      : initials(this.user()),
  );
}

function initials(user: AvatarUserInfo): string {
  const name = user.displayName || user.bbUserName;
  return (
    name
      ?.split(/\s+/g, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join('') || '?'
  );
}
